import { render } from "./WxQrAuthDialog.vue?vue&type=template&id=94c35a18&scoped=true"
import script from "./WxQrAuthDialog.vue?vue&type=script&lang=js"
export * from "./WxQrAuthDialog.vue?vue&type=script&lang=js"

import "./WxQrAuthDialog.vue?vue&type=style&index=0&id=94c35a18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94c35a18"]])

export default __exports__